module.exports = __webpack_public_path__ + "static/preset-column-2-417f8288830c11fefd11614566fecb6e.png";